'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuthStore } from '@/entities/auth';
import { ENV } from '@/shared/config';
import { getHostOrigin } from '@/shared/lib/path';
import { login, logout } from '@/shared/utils';
export const useGnbAuth = () => {
  const $ = _c(6);
  const {
    user,
    isLoading,
    isAuthenticated
  } = useAuthStore();
  let t0;
  if ($[0] !== user) {
    t0 = user ? {
      ...user,
      profileUrl: ENV.MY_APP
    } : null;
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const gnbUser = t0;
  const handleLogin = _temp;
  const handleLogout = _temp2;
  let t1;
  if ($[2] !== gnbUser || $[3] !== isAuthenticated || $[4] !== isLoading) {
    t1 = {
      gnbUser,
      isLoading,
      isAuthenticated,
      handleLogin,
      handleLogout
    };
    $[2] = gnbUser;
    $[3] = isAuthenticated;
    $[4] = isLoading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
function _temp() {
  const hostName = getHostOrigin();
  login(ENV.AUTH_API_BASE_URL, hostName);
}
function _temp2() {
  const hostName_0 = getHostOrigin();
  logout(ENV.AUTH_API_BASE_URL, hostName_0);
}